<script setup>
const { getNuxtLink, isExternal } = useCustomLink()
defineProps({
  result: {
    type: Array,
    default: () => []
  }
})
// const runtimeConfig = useRuntimeConfig()
// const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
</script>

<template>
  <div class="searchCandidate">
    <NuxtLink
      v-for="item in result"
      :key="item.citycode"
      class="link"
      :to="getNuxtLink(item.link)"
      :external="isExternal(item.link)"
    >
      <p class="city">
        {{ item.city_kanji }}
      </p>
      <p class="country">
        {{ item.prefcode.title }}
      </p>
    </NuxtLink>
    <p
      v-if="result.length === 0"
      class="result"
    >
      該当する市区町村が見つかりませんでした。
    </p>
  </div>
</template>

<style lang="scss" scoped>
.searchCandidate {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  max-height: 450px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.25);
  z-index: 1;
  overflow-y: scroll;
  border-top: solid 1px #D8E0DF;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 100vmax;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #438fec;
  }
  .link {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px 20px 5px 10px;
    cursor: pointer;
    border-bottom: solid 1px #D8E0DF;
    &::after {
      position: absolute;
      top: 50%;
      right: 10px;
      width: 8px;
      height: 8px;
      border-top: solid 2px #303030;
      border-right: solid 2px #303030;
      transform: translateY(-50%) rotate(45deg);
      content: "";
    }
  }
  .city {
    color: #3569c0;
    font-weight: 600;
    line-height: 17px;
  }
  .country {
    color: #808080;
    font-size: 13px;
    line-height: 15px;
  }
  .result {
    padding: 5px 20px 5px 10px;
  }
  @media (any-hover: hover) {
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
